/**
 * 將可能為英文的錯誤訊息對應為中文，供前端 toast 顯示用。
 */
const EN_TO_ZH: Array<{ pattern: RegExp | string; zh: string }> = [
  // Zod 驗證
  { pattern: /expected number.*received/i, zh: "請輸入有效的數字" },
  { pattern: /expected string.*received/i, zh: "請輸入有效內容" },
  { pattern: /Invalid (input|type)/i, zh: "請檢查並填寫必填欄位" },
  { pattern: /required/i, zh: "請填寫此欄位" },
  { pattern: /String must contain at least/i, zh: "請檢查並填寫必填欄位" },
  // 網路 / 請求
  { pattern: /network (error|failed)/i, zh: "網路異常，請檢查連線後再試" },
  { pattern: /timeout/i, zh: "請求逾時，請稍後再試" },
  { pattern: /fetch failed/i, zh: "無法連線，請稍後再試" },
  { pattern: /Failed to fetch/i, zh: "無法連線，請稍後再試" },
  { pattern: /status (code )?4\d{2}/i, zh: "請求錯誤，請稍後再試" },
  { pattern: /status (code )?5\d{2}/i, zh: "伺服器錯誤，請稍後再試" },
];

/**
 * 若訊息為英文或已知格式，回傳對應中文；否則回傳原訊息（可能已是中文）或預設中文。
 */
export function toToastMessage(
  message: string | undefined | null,
  defaultZh: string = "發生錯誤，請稍後再試",
): string {
  const raw = (message ?? "").trim();
  if (!raw) return defaultZh;
  for (const { pattern, zh } of EN_TO_ZH) {
    if (typeof pattern === "string" ? raw.includes(pattern) : pattern.test(raw)) {
      return zh;
    }
  }
  // 若看起來已是中文（含常見中文字）則直接回傳
  if (/[\u4e00-\u9fff]/.test(raw)) return raw;
  return defaultZh;
}
